import { Attributes, CartSummary, PickupSettings, Variation } from '../types/store-types';
import { getAdminRoute, getWcRoute } from './api-builder';

export type GetVariationPayload = { product_id: number } & Attributes;
export type GetVariationResponse = Variation | { error: string };
export const getVariation = getAdminRoute<GetVariationResponse, GetVariationPayload>(
  'get_variation',
);

export const getCartContentsCount = getAdminRoute<number>('get_cart_contents_count');

export type AddToCartPayload = { product_id: number; quantity: number };
export const addToCart = getWcRoute<{ cart_hash: string }, AddToCartPayload>('add_to_cart');

export type RemoveFromCartPayload = { item_key: string };
export const removeFromCart = getAdminRoute<CartSummary, RemoveFromCartPayload>('remove_from_cart');

export type UpdateCartItemQuantityPayload = { item_key: string; quantity: number };
export const updateCartItemQuantity = getAdminRoute<CartSummary, UpdateCartItemQuantityPayload>(
  'update_cart_item_quantity',
);

export const getPickupSettings = getAdminRoute<PickupSettings>('get_pickup_settings');

export default {
  getVariation,
  getCartContentsCount,
  addToCart,
  removeFromCart,
  updateCartItemQuantity,
  getPickupSettings,
};
